import { jsPDF } from "jspdf";
import { MANUAL } from "./manual";

const TEAL = [13, 148, 136];

export function manualPDF() {
  const doc = new jsPDF({ unit: "pt", format: "letter" });
  const W = doc.internal.pageSize.getWidth() - 100;
  const H = doc.internal.pageSize.getHeight();
  let y = 60;
  const room = (h) => { if (y + h > H - 50) { doc.addPage(); y = 60; } };
  const para = (text, size, style = "normal", color = [30, 30, 30], gap = 4) => {
    doc.setFont("helvetica", style).setFontSize(size).setTextColor(...color);
    doc.splitTextToSize(text, W).forEach((line) => { room(size + 4); doc.text(line, 50, y); y += size + 4; });
    y += gap;
  };
  para("Household Budget — User Manual", 22, "bold", TEAL, 6);
  para(`Version of ${new Date().toLocaleDateString()}`, 9, "normal", [120, 120, 120], 14);
  para("Contents", 13, "bold");
  MANUAL.forEach((c, i) => para(`${i + 1}. ${c.title}`, 10, "normal", [60, 60, 60], 0));
  MANUAL.forEach((c, i) => {
    doc.addPage();
    y = 60;
    para(`${i + 1}. ${c.title}`, 17, "bold", TEAL, 4);
    para(c.intro, 10.5, "italic", [80, 80, 80], 10);
    c.topics.forEach((t) => {
      room(40);
      para(t.h, 11.5, "bold", [20, 20, 20], 0);
      t.p.forEach((p) => para(p, 10, "normal", [40, 40, 40], 6));
    });
  });
  const n = doc.getNumberOfPages();
  for (let p = 1; p <= n; p++) {
    doc.setPage(p);
    doc.setFont("helvetica", "normal").setFontSize(8).setTextColor(140).text(`Household Budget user manual · page ${p} of ${n}`, 50, H - 24);
  }
  doc.save("household-budget-user-manual.pdf");
}
